import { Box, Button, CircularProgress, Grid, Menu, MenuItem, Paper, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Widget from "../../components/Widget/Widget";
import useStyles from "./styles";
import { ArrowDropDown } from "@material-ui/icons";
import config from "../../config";
import { ReferralState, addReferralData, editReferralData, getRefarralDatabyID } from "../../context/ReferralCodeContext";
import history from "../../common/history";
import { withRouter } from 'react-router-dom';

const Addreferralcode = props => {

    const context = ReferralState();
    const classes = useStyles();
    const [user_id, setUser_id] = useState(null);
    const [userData, setUserData] = useState({});

    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl1, setAnchorEl1] = useState(null);
    const [data, setData] = useState({
        referral_code: "",
        time_duration: null,
        subscription_role: null
    });
    const openDropdown = Boolean(anchorEl);
    const openDropdown1 = Boolean(anchorEl1);

    useEffect(() => {
        if (props.location?.state && props.location.state?.id) {
            setUser_id(props.location.state.id);
            getReferralUserDataByID(props.location.state.id);
        } else {
            setData({
                referral_code: "",
                time_duration: null,
                subscription_role: null
            })
        }
    }, []);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelectTimePeriod = (item) => {
        setData((prev) => ({
            ...prev,
            time_duration: item
        }))
        handleClose();
    };

    const handleClick1 = (event) => {
        setAnchorEl1(event.currentTarget);
    };

    const handleClose1 = () => {
        setAnchorEl1(null);
    };

    const handleSelectSubscriptionRole = (item) => {
        setData((prev) => ({
            ...prev,
            subscription_role: item.id
        }))
        handleClose1();
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setData((prev) => ({
            ...prev,
            referral_code: value
        }))
    };

    const validate = () => {
        if (data.referral_code.length == 0) return false;
        else if (data.subscription_role == null) return false;
        else if (data.time_duration == null) return false;
        else return true;
    };

    const handleAddReferralCode = async () => {
        if (validate()) {
            const reqData = {
                "referral_code": data.referral_code,
                "role": data.subscription_role,
                "duration_in_days": data.time_duration
            }
            await addReferralData(context.setAllReferralData, reqData);
            history.back();
        }
    };

    const handleEditReferralCode = async () => {
        if (validate()) {
            const reqData = {
                "referral_code": data.referral_code,
                "role": data.subscription_role,
                "duration_in_days": data.time_duration,
                "code_id": user_id
            }
            await editReferralData(context.setAllReferralData, reqData);
            history.back();
        }
    };

    const getReferralUserDataByID = async (id) => {
        const reqData = {
            code_id: id || user_id
        }
        await getRefarralDatabyID(context.setAllReferralData, reqData);
    };

    useEffect(() => {
        if (context.AllReferralData.UserData.length > 0) {
            setUserData(context.AllReferralData.UserData[0]);
            setData({
                referral_code: context.AllReferralData.UserData[0].referral_code,
                subscription_role: context.AllReferralData.UserData[0].subscription_role,
                time_duration: context.AllReferralData.UserData[0].duration_in_days
            })
        }
    }, [context.AllReferralData.isLoaded])

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Widget inheritHeight>
                        <Grid container spacing={5}>
                            <Grid item md={4} xs={4} sm={4}>
                                <Box>
                                    <span className={classes.mainPageTitle}><b>{user_id == null ? "Add Referral Code" : "Edit Referral Code"}</b>
                                    </span>
                                </Box>
                            </Grid>
                        </Grid>
                    </Widget>
                </Grid>
                {!context.AllReferralData.isLoaded ? (
                    <Box
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        width={"100vw"}
                        height={"calc(100vh - 200px)"}
                    >
                        <CircularProgress size={50} />
                    </Box>
                ) : (
                    <div className='smallTable'>
                        <Grid item xs={12}>
                            <Paper className={classes.root}>
                                <div className={classes.textFieldMainContainer}>
                                    <div className={classes.textFieldContainer}>
                                        <p style={{ paddingTop: "20px", fontSize: "18px", width: "20%", marginLeft: "20px" }}>Referral Code :</p>
                                        <Box
                                            display={'flex'}
                                            flexDirection={'column'}
                                            marginTop={'10px'}
                                            marginLeft={'10px'}
                                            width={'80%'}
                                        >
                                            <TextField
                                                fullWidth
                                                id="search-field"
                                                margin="dense"
                                                variant="outlined"
                                                onChange={(e) => handleChange(e)}
                                                value={data.referral_code}
                                                type='text'
                                                placeholder='Referral Code'
                                            />
                                        </Box>
                                    </div>
                                    <div style={{ marginTop: "20px" }} className={classes.textFieldContainer}>
                                        <p style={{ fontSize: "18px", width: "20%", marginLeft: "20px" }}>Time Period :</p>
                                        <div style={{ width: "80%", marginLeft: "10px" }}>
                                            <Button
                                                id="demo-positioned-button"
                                                color="primary"
                                                style={{ cursor: 'pointer', }}
                                                variant='contained'
                                                aria-controls={openDropdown ? 'demo-positioned-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={openDropdown ? 'true' : undefined}
                                                onClick={handleClick}
                                            >
                                                {data.time_duration == null ? "Select Time " : `${data.time_duration} Days`}
                                                <ArrowDropDown />
                                            </Button>
                                        </div>
                                        <Menu
                                            id="demo-positioned-menu"
                                            aria-labelledby="demo-positioned-button"
                                            anchorEl={anchorEl}
                                            open={openDropdown}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                        >
                                            {
                                                config.timePeriod_referral.map((item, index) => {
                                                    return (
                                                        <MenuItem onClick={() => handleSelectTimePeriod(item)} style={{ width: "150px" }}>{item} Days</MenuItem>
                                                    )
                                                }
                                                )
                                            }
                                        </Menu>
                                    </div>
                                    <div style={{ marginTop: "20px" }} className={classes.textFieldContainer}>
                                        <p style={{ fontSize: "18px", width: "20%", marginLeft: "20px" }}>Subscription Role :</p>
                                        <div style={{ width: "80%", marginLeft: "10px" }}>
                                            <Button
                                                id="demo-positioned-button"
                                                color="primary"
                                                style={{ cursor: 'pointer', }}
                                                variant='contained'
                                                aria-controls={openDropdown1 ? 'demo-positioned-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={openDropdown1 ? 'true' : undefined}
                                                onClick={handleClick1}
                                            >
                                                {
                                                     data.subscription_role == 1 ? "Basic" 
                                                    : data.subscription_role == 3 ? "Investor" 
                                                    : data.subscription_role == 5 ? "Partnership" 
                                                    : "Select Subscription"}
                                                <ArrowDropDown />
                                            </Button>
                                        </div>
                                        <Menu
                                            id="demo-positioned-menu"
                                            aria-labelledby="demo-positioned-button"
                                            anchorEl={anchorEl1}
                                            open={openDropdown1}
                                            onClose={handleClose1}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                        >
                                            {
                                                config.subscriptionRole.map((item, index) => {
                                                    return (
                                                        <MenuItem onClick={() => handleSelectSubscriptionRole(item)} style={{ width: "200px" }}>{item.role}</MenuItem>
                                                    )
                                                }
                                                )
                                            }
                                        </Menu>
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => user_id == null ? handleAddReferralCode() : handleEditReferralCode()}
                                    >
                                        {user_id == null ? "Add Referral" : "Edit Referral"}
                                    </Button>
                                </div>
                            </Paper>
                        </Grid>
                    </div>
                )}
            </Grid>
        </>
    )
}

export default withRouter(Addreferralcode);